module.exports = __webpack_public_path__ + "static/media/YM49_1.fcc2e9b3.jpg";